import { OverlayContainer } from '@angular/cdk/overlay';
import { Location } from '@angular/common';
import {
    Inject,
    Injectable,
    Injector,
    Optional,
    Renderer2,
    SkipSelf,
} from '@angular/core';

import {
    MatDialog,
    MatDialogConfig,
    MAT_DIALOG_SCROLL_STRATEGY,
} from '@angular/material/dialog';

import { DynamicOverlay } from './dynamic-overlay';

@Injectable({
    providedIn: 'root',
})
export class DynamicMatDialog extends MatDialog {
    public static $name = "clDynamicMatDialog";
    private _customOverlay: DynamicOverlay;

    constructor(
        _overlay: DynamicOverlay,
        _injector: Injector,
        @Optional() location: Location,
        @Optional() defaultOptions: MatDialogConfig,
        @Inject(MAT_DIALOG_SCROLL_STRATEGY) _scrollStrategy,
        @Optional() @SkipSelf() _parentDialog: DynamicMatDialog,
        overlayContainer: OverlayContainer
    ) {
        super(
            _overlay,
            _injector,
            location,
            defaultOptions,
            _scrollStrategy,
            _parentDialog,
            overlayContainer
        );

        this._customOverlay = _overlay;
    }

    public setContainerElement(
        containerElement: HTMLElement,
        renderer: Renderer2
    ): void {
        // need to apply this styling to make the backdrop with position: fixed styling cover only the containerElement
        renderer.setStyle(containerElement, 'transform', 'translateZ(0)');

        this._customOverlay.setContainerElement(containerElement);
    }
}
